import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgAlertTriangle = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.0001 17.4C11.9407 17.4 11.8827 17.4176 11.8334 17.4505C11.7841 17.4835 11.7456 17.5303 11.7229 17.5852C11.7002 17.64 11.6943 17.7003 11.7058 17.7585C11.7174 17.8167 11.746 17.8701 11.7879 17.9121C11.8299 17.9541 11.8834 17.9826 11.9415 17.9942C11.9997 18.0058 12.0601 17.9998 12.1149 17.9771C12.1697 17.9544 12.2166 17.916 12.2495 17.8666C12.2825 17.8173 12.3001 17.7593 12.3001 17.7C12.3001 17.6204 12.2685 17.5441 12.2122 17.4878C12.1559 17.4316 12.0796 17.4 12.0001 17.4Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.20001}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15V8.99992"
          stroke="currentColor"
          strokeWidth={1.20001}
          strokeLinecap="round"
        />
        <path
          d="M13.2968 3.80782C13.1777 3.56543 12.9931 3.36126 12.7639 3.21847C12.5347 3.07569 12.27 3 12 3C11.7299 3 11.4653 3.07569 11.2361 3.21847C11.0068 3.36126 10.8222 3.56543 10.7032 3.80782L3.12469 19.2464C3.03346 19.432 2.99103 19.6377 3.00141 19.8442C3.01179 20.0508 3.07462 20.2512 3.18399 20.4267C3.29336 20.6022 3.44564 20.747 3.62647 20.8473C3.8073 20.9476 4.01071 21.0001 4.2175 21H19.7825C19.9892 21.0001 20.1927 20.9476 20.3735 20.8473C20.5543 20.747 20.7066 20.6022 20.816 20.4267C20.9253 20.2512 20.9882 20.0508 20.9985 19.8442C21.0089 19.6377 20.9665 19.432 20.8753 19.2464L13.2968 3.80782Z"
          stroke="currentColor"
          strokeWidth={1.20001}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgAlertTriangle.displayName = 'SvgAlertTriangle';
export default SvgAlertTriangle;
